angular.module('zc.zenclerkS')
  .controller('SiteLogoImageController', SiteLogoImageController);

SiteLogoImageController.$inject = ['$scope', 'ZcsImage'];
function SiteLogoImageController($scope, ZcsImage) {
  $scope.$on('flow::fileAdded', function(event, $flow, flowFile) {
    event.preventDefault();
    return ZcsImage.create(
      {projectId: $scope.$parent.vm.project.id}
      , {
        image: flowFile.file,
        is_site_logo: 1
      }).then(res => {
      $scope.$parent.vm.project.site_logo_image_id = res.data.image.id;
      $scope.$parent.siteSettings.$setDirty();
    });
  });
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/settings/site_logo_image.controller.js